import ItemListViewModel from "../view/itemlistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedItems extends PagedElements<ItemListViewModel> {
    constructor(init?: Partial<PagedItems>) { super(init); }
}